import React, { useContext, useState, useEffect, useRef, useMemo } from 'react';
import './login.css';
import { clearEventsLogin } from '../../utils/eventsLogin';
import { final_registration, initial_registration, VerifyLoginCredential } from '../../Services/Login/LoginApi';
import { AuthContext, LoaderContext } from '../../Context/ContextProvider';
import { useNavigate, useSearchParams } from 'react-router-dom';
import loginBackgroundImage from '../../Assets/Images/SignupBackground.jpg';
import filedown from '../../Assets/Images/file-down.png';
import SignupPage2 from '../../Assets/Images/SignupPage2.jpg';
import SignupPage3 from '../../Assets/Images/SignupPage3.jpg';
import SuccessModel from '../../Componant/SuccessModel';
import { JobType, RelocationPreferences } from '../middleware/Enum';
import { FaCircleXmark } from 'react-icons/fa6';
import { get_list_filter_signup } from '../../Services/Student/StudentApi';
import ErrorModel from '../../Componant/ErrorModel';
import GoogleLoginButton from './GoogleLoginButton';
import AlertModal from '../../Componant/AlertModel';
import SignUpLoader from '../../Componant/Loader/SignUpLoader';
import { FaTimes } from 'react-icons/fa';
const DEFAULT_RELOCATION_PREFERENCE = 'Yes, Anywhere';
const Login = () => {
  useState(() => { clearEventsLogin(); return null; });
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(false);
  const [CustomError, setCustomError] = useState('');
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [customLoader, setCustomLoader] = useState(false);
  const [LoginData, setLoginData] = useState({});
  const [retypePasswordVisible, setRetypePasswordVisible] = useState(false);
  const { setLoginItem, setUserRole, selectedFilters } = useContext(AuthContext);
  const { setLoader } = useContext(LoaderContext);
  const [passwordStrength, setPasswordStrength] = useState('');
  const [isAlertOpen, setIsAlertOpen] = useState(false); // for error alert

  const [initialLoginsuccessPopUp, setInitialLoginsuccessPopUp] = useState(false);
  const [finalLoginsuccessPopUp, setFinalLoginsuccessPopUp] = useState(false);
  const [message, setMessage] = useState('');
  const [isOpenErrorModel, setOpenErrorModel] = useState(false);
  const [initialLoginSuccessMessage, setInitialLoginSuccessMessage] = useState(null);
  const [finalLoginSuccessMessage, setFinalLoginSuccessMessage] = useState(null);
  const [OpenFormID, setOpenFormID] = useState(1);
  const [isGoogleSSOFlow, setIsGoogleSSOFlow] = useState(false);
  const [signupForm, setSignUpForm] = useState({
    fullName: null,
    emailID: null,
    password: null,
    confirmPassword: null,
    jobType: [],
    interestedIn: [],
    relocationPreferences: DEFAULT_RELOCATION_PREFERENCE,
    relocationPreferencesName: null,
    expectedSalary: '',
    city: [],
    resumeFile: null,
    ID: null,
  });
  const [tempFilters, setTempFilters] = useState(selectedFilters);

  // Optional: Sync if parent updates the selected filters
  useEffect(() => {
    setTempFilters(selectedFilters);
  }, [selectedFilters]);

  const handleTempFilterChange = (filterName, value) => {
    // For single selection: salaryRanges
    if (filterName === 'salaryRanges') {
      setTempFilters(prevFilters => ({
        ...prevFilters,
        [filterName]: value, // store the single selected value
      }));

      setSignUpForm(prev => ({
        ...prev,
        expectedSalary: value, // store the single selected salary directly
      }));

      return; // exit the function
    }

    // For multi-selection: jobTitles
    if (filterName === 'jobTitles') {
      setTempFilters(prevFilters => {
        const existingValues = prevFilters[filterName] || [];

        let updatedValues;
        if (existingValues.includes(value)) {
          updatedValues = existingValues.filter(item => item !== value);
        } else {
          updatedValues = [...existingValues, value];
        }

        // Sync with signupForm in real-time
        setSignUpForm(prev => ({
          ...prev,
          interestedIn: updatedValues,
        }));

        return {
          ...prevFilters,
          [filterName]: updatedValues,
        };
      });

      return; // exit the function
    }

    // Add more filters if needed
  };

  const [filters, setFilters] = useState({}); // State to hold filters fetched from API

  useEffect(() => {
    const step = searchParams.get('step');
    const id = searchParams.get('id');
    const name = searchParams.get('name');
    const userType = localStorage.getItem('Type');
    const ssoProvider = localStorage.getItem('SSOProvider');

    if (step === '2' && id) {
      setIsGoogleSSOFlow(ssoProvider === 'google');
      setOpenFormID(2);
      fetchFiltersData();

      const seekerData = JSON.parse(localStorage.getItem('seekerData'));
      const parsedID = parseInt(id);
      const isSameSeeker = seekerData && parsedID === seekerData.id;

      const updatedForm = {
        ID: parsedID,
        fullName: isSameSeeker ? seekerData.name : name || '', // prefer query name only if not matched in seekerData
      };

      setSignUpForm(prev => ({
        ...prev,
        ...updatedForm,
      }));

      navigate('/sign-up', { replace: true });
    }
  }, [searchParams, navigate]);

  useEffect(() => setCustomError(null), [signupForm]);
  const fetchFiltersData = async () => {
    setLoader(true);
    try {
      const response = await get_list_filter_signup(); // Fetch the actual data
      if (response) {
        const updatedResponse = {
          ...response,
          datePosted: ['Past 24 hours', 'Past 3 days', 'Past Week', 'Past Month'],
          experienceLevels: ['Intern', 'Entry Level', 'Mid Level', 'Senior Level'],
          workAuthorization: ['Visa Sponsorship'],
        };
        setFilters(updatedResponse); // Set the filters with the added fields
      }
    } catch (error) {
      console.error('Failed to fetch filters:', error);
    } finally {
      setLoader(false);
    }
  };
  const handleLogin = async () => {
    // setOpenFormID(2)
    let errors = [];

    if (!signupForm?.fullName) {
      errors.push('Full Name is required.');
    }

    if (!signupForm?.emailID) {
      errors.push('Email Address is required.');
    } else if (!isValidEmail(signupForm.emailID)) {
      errors.push('Please enter a valid email address.');
    } else if (isDisposableEmail(signupForm.emailID)) {
      errors.push('Disposable or temporary email addresses are not allowed. Please use a permanent email.');
    }

    if (!signupForm?.password) {
      errors.push('Password is required.');
    } else {
      if (signupForm.password.length < 8) {
        errors.push('Password must be at least 8 characters long.');
      }
      if (!/[A-Z]/.test(signupForm.password)) {
        errors.push('Password must contain at least one uppercase letter.');
      }
      if (!/[a-z]/.test(signupForm.password)) {
        errors.push('Password must contain at least one lowercase letter.');
      }
      if (!/\W/.test(signupForm.password)) {
        errors.push('Password must contain at least one special character.');
      }
    }

    if (!signupForm?.confirmPassword) {
      errors.push('Retype Password is required.');
    } else if (signupForm?.confirmPassword !== signupForm?.password) {
      errors.push('Passwords do not match.');
    }

    if (errors.length > 0) {
      setError(true);
      setCustomError(errors.join('\n'));
      // setIsAlertOpen(true); // Show alert modal
      return;
    }

    setLoader(true);
    const data = await initial_registration({
      full_name: signupForm?.fullName,
      email: signupForm?.emailID,
      password: signupForm?.password,
    });

    if (!data?.code?.includes('ERR')) {
      setLoader(false);
      setInitialLoginSuccessMessage(data.message);
      setSignUpForm({
        ...signupForm,
        ID: data.seeker_id || data.student_id,
      });
      setInitialLoginsuccessPopUp(true);
    } else {
      setLoader(false);
      setCustomError(data?.response?.data?.error || data?.response?.data?.error || 'Registration failed.');
      setIsAlertOpen(true);
    }
  };
  const allowedTypes = [
    'application/pdf', // PDF
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
    'text/plain', // .txt
  ];
  const handleRegister = async () => {
    try {
      if (!signupForm.resumeFile) {
        setCustomError('Please upload your resume before proceeding.');
        setIsAlertOpen(true);
        return;
      }

      // ✅ Validate file type & size (15 MB = 15 * 1024 * 1024 bytes)
      if (!allowedTypes.includes(signupForm.resumeFile.type) || signupForm.resumeFile.size > 15 * 1024 * 1024) {
        setCustomError('Accepted file types: .docx, .pdf, .txt\nMaximum file size: 15 MB');
        setIsAlertOpen(true);
        return;
      }

      // ✅ Validate required fields
      const missingFields = [];
      if (!signupForm.jobType) missingFields.push('Job Type');
      if (!signupForm.interestedIn) missingFields.push('Interested In');
      // if (!signupForm.relocationPreferences) missingFields.push('Relocation Preferences');

      if (missingFields.length > 0) {
        setCustomError('The following fields are required: ' + missingFields.join(', ') + '.');
        setIsAlertOpen(true);
        return;
      }

      setCustomLoader(true);
      const seeker_id = signupForm.ID;

      const formData = new FormData();
      formData.append('resume', signupForm.resumeFile);

      const registrationData = {
        stepCsData: {
          JobSeekerId: seeker_id || '',
          fullName: signupForm?.fullName || '',
          currentSituation: signupForm?.currentSituation || '',
        },
        stepEduData: {
          highestEducation: signupForm?.highestEducation || '',
          schoolName: signupForm?.schoolName || '',
          fieldOfStudy: signupForm?.fieldOfStudy || '',
          graduationYear: signupForm?.graduationYear || '',
          skills: signupForm?.skills || [],
          certifications: signupForm?.certifications || '',
        },
        stepJpData: {
          jobType: signupForm?.jobType || [],
          jobTitle: signupForm?.interestedIn || [],
          country: signupForm?.relocationPreferences || DEFAULT_RELOCATION_PREFERENCE,
          cities: signupForm?.city || [],
          salaryRange: signupForm?.expectedSalary || '',
        },
      };

      formData.append('registrationData', JSON.stringify(registrationData));

      const response = await final_registration(formData);

      if (!response?.code?.includes('ERR')) {
        let role = '';
        let user = {};
        if (response?.seeker?.id) {
          role = 'seeker';
          user = {
            seeker: { id: response?.seeker?.id },
            role,
          };
        } else {
          role = 'student_registered';
          user = {
            student: { id: response.student.id },
            role,
          };
        }

        let loginData = { message: role, role, is_sso: false, provider: 'email' };
        if (isGoogleSSOFlow) {
          loginData.is_sso = true;
          loginData.provider = 'google';
        }
        if (role === 'seeker') {
          loginData.seeker = {
            id: response.seeker.id,
            thumbnail: response.seeker.thumbnail,
            name: response.seeker.name,
          };
        } else {
          loginData.student = {
            id: response.student.id,
            thumbnail: response.student.thumbnail,
            name: response.student.name,
          };
        }

        localStorage.setItem('login', JSON.stringify(loginData));
        localStorage.removeItem('Type');
        localStorage.removeItem('SSOProvider');
        setCustomLoader(false);
        setLoginItem(loginData);
        navigate('/');
      } else {
        setCustomLoader(false);
        setOpenErrorModel(true);
        setMessage(response.response.data.error);
      }
    } catch (error) {
      setCustomLoader(false);
      setOpenErrorModel(true);
      setMessage(error);
      console.error('Registration error:', error);
    }
  };

  const handleNextClicked = async () => {
    let isValid = true;

    if (
      signupForm?.jobType.length === 0 || // Job type required
      signupForm.interestedIn.length === 0
    ) {
      isValid = false;
      setError(true);
    }

    if (isValid) {
      setError(false);
      setOpenFormID(3);
    }
  };

  const isValidEmail = email => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;
    return regex.test(email);
  };

  const isDisposableEmail = email => {
    if (!email) return false;
    const domain = email.split('@')[1]?.toLowerCase();
    const disposableDomains = [
      'mailinator.com',
      '10minutemail.com',
      'guerrillamail.com',
      'temp-mail.org',
      'yopmail.com',
      'throwawaymail.com',
      'mailslurp.com',
      'mailticking.com',
      'tempmail.com',
      'sharklasers.com',
      'dispostable.com',
      'maildrop.cc',
      'getnada.com',
      'tempmailaddress.com',
      'temp-mail.io',
      'tempmail.net',
      'fakeinbox.com',
      'trashmail.com',
      'trashmail.net',
      'minuteinbox.com',
      'mohmal.com',
      'mytrashmail.com',
      'generator.email',
      'inboxkitten.com',
      'tempmail.altmails.com',
      'adguard.com',
      'toolpix.net',
    ];
    return disposableDomains.includes(domain);
  };

  const InitialLoginSuccessUpdate = () => {
    setInitialLoginsuccessPopUp(false);
    setError(false);
  };

  const JobTitleFilter = ({ filters, selectedValues, onSelect }) => {
    const BATCH_SIZE = 50;
    const [searchTerm, setSearchTerm] = useState('');
    const [visibleCount, setVisibleCount] = useState(100);
    const filterRef = useRef(null);
    const [isDropdownOpen, setDropdownOpen] = useState(false);
    const allJobTitles = Object.values(filters.Job_Titles_and_Category || {}).flatMap(
      details => details['Job Titles'] || details['Occupations'] || [],
    );

    const filteredJobTitles = searchTerm.trim()
      ? filters.job_titles.filter(title => title.toLowerCase().includes(searchTerm.toLowerCase()))
      : filters.job_titles;

    const handleScroll = e => {
      const { scrollTop, scrollHeight, clientHeight } = e.target;
      if (scrollTop + clientHeight >= scrollHeight - 20) {
        setVisibleCount(prev => prev + BATCH_SIZE);
      }
    };

    const handleSelect = jobTitle => {
      onSelect('jobTitles', jobTitle);
      setDropdownOpen(false); // close first
      setTimeout(() => {
        setSearchTerm(''); // clear after dropdown is hidden
      }, 0);
    };

    const handleRemove = jobTitle => {
      onSelect('jobTitles', jobTitle);
    };

    const handleKeyDown = e => {
      if (e.key === 'Enter' && searchTerm.trim() !== '') {
        const normalized = searchTerm.trim().toLowerCase();
        const isExisting = allJobTitles.some(title => title.toLowerCase() === normalized);
        const isSelected = selectedValues.includes(searchTerm.trim());

        if (isExisting || !isSelected) {
          handleSelect(searchTerm.trim());
        }
      }
    };
    const handleSearch = e => {
      const value = e.target.value;
      setSearchTerm(value);
      if (!isDropdownOpen && value.trim() !== '') {
        setTimeout(() => setDropdownOpen(true), 0);
      }
    };
    // Close dropdown on outside click
    useEffect(() => {
      const handleClickOutside = e => {
        if (filterRef.current && !filterRef.current.contains(e.target)) {
          setDropdownOpen(false);
        }
      };
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [setDropdownOpen]);

    const noMatchFound = searchTerm.trim() && filteredJobTitles.length === 0;

    return (
      <div ref={filterRef} className="job-title-search-filter relative">
        {/* Selected Tags */}
        <div className="selected-tags mb-2 flex flex-wrap gap-2">
          {selectedValues.map(title => (
            <span key={`jobType-${title}`} className="filter-chip signup-filter-chip">
              <span className="signup-chip-label">{title}</span>
              <span className="close-btn signup-chip-close" onClick={() => handleRemove(title)}>
                <FaCircleXmark />
              </span>
            </span>
          ))}
        </div>

        {/* Search Input */}
        <div className="search-input-wrapper relative">
          <i className="fa-solid fa-magnifying-glass search-icon absolute left-3 top-1/2 transform -translate-y-1/2"></i>
          <input
            type="text"
            placeholder="Add Job Title(s)"
            value={searchTerm}
            onChange={e => {
              handleSearch(e);
            }}
            onKeyDown={handleKeyDown}
            className="search-input pl-10 w-full border rounded p-2"
          />
        </div>

        {/* Dropdown */}
        {isDropdownOpen && (
          <div
            onScroll={handleScroll}
            className="job-title-dropdown absolute bg-white shadow rounded w-full mt-1 z-10 max-h-60 overflow-y-auto"
          >
            {filteredJobTitles.length !== 0 ? (
              filteredJobTitles.slice(0, visibleCount).map((title, index) => (
                <label key={index} className="checkbox-option flex items-center px-3 py-2 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={selectedValues.includes(title)}
                    onChange={() => handleSelect(title)}
                    style={{ width: '10%', margin: 0 }}
                    className="mr-2"
                  />
                  {title}
                </label>
              ))
            ) : noMatchFound ? (
              <div
                className="p-2 text-blue-600 bg-blue-50 rounded cursor-pointer"
                role="button"
                onClick={() => handleSelect(searchTerm.trim())}
              >
                Create a custom job function with "{searchTerm.trim()}"
              </div>
            ) : (
              <div className="p-2 text-gray-500">No matching job titles.</div>
            )}
          </div>
        )}
      </div>
    );
  };
  function FilterLocationItem({ filters, onSelect, selectedValues = [] }) {
    const [searchValues, setSearchValues] = useState(['']);
    const [matchedLocations, setMatchedLocations] = useState([[]]);

    const allLocations = useMemo(() => {
      const locations = [];

      (filters.us_state_city || []).forEach(country => {
        (country.states || []).forEach(state => {
          locations.push({
            type: 'state',
            label: `${state.name} (${state.code})`,
            value: state.code,
            state: state.name,
            stateCode: state.code,
          });

          (state.cities || []).forEach(city => {
            locations.push({
              type: 'city',
              label: `${city}, ${state.code}`,
              value: `${city}, ${state.code}`,
              city,
              stateCode: state.code,
            });
          });
        });
      });

      return locations;
    }, [filters]);
    const getRawLocationValue = value => {
      const trimmedValue = typeof value === 'string' ? value.trim() : '';
      if (!trimmedValue) return null;
      const matched = allLocations.find(loc => loc.label === trimmedValue || loc.value === trimmedValue);
      return matched?.value || null;
    };

    // Convert raw selected values (e.g., "CA", "New York, NY") to display labels
    useEffect(() => {
      if (Array.isArray(selectedValues) && selectedValues.length > 0) {
        const resolved = selectedValues.map(val => {
          const match = allLocations.find(loc => {
            if (loc.type === 'state' && loc.value === val) return true;
            if (loc.type === 'city' && loc.value === val) return true;
            return false;
          });

          return match ? match.label : '';
        });

        const validResolved = resolved.filter(Boolean);
        setSearchValues(validResolved.length ? validResolved : ['']);
        setMatchedLocations((validResolved.length ? validResolved : ['']).map(() => []));
      }
    }, [selectedValues, allLocations]);

    const handleLocationSearch = (index, e) => {
      const value = e.target.value;
      const updatedSearchValues = [...searchValues];
      updatedSearchValues[index] = value;
      setSearchValues(updatedSearchValues);

      if (value.trim().length === 0) {
        const updatedMatches = [...matchedLocations];
        updatedMatches[index] = [];
        setMatchedLocations(updatedMatches);
        return;
      }

      const searchTerm = value.toLowerCase();
      const normalize = str => str?.toLowerCase().replace(/\s+/g, ' ').trim();

      const filtered = allLocations.filter(loc => {
        const search = normalize(searchTerm);
        const label = normalize(loc.label);
        const initials = loc.label
          .split(/[\s,()]+/)
          .map(word => word.charAt(0).toLowerCase())
          .join('');
        return label.includes(search) || initials.startsWith(search);
      });

      const updatedMatches = [...matchedLocations];
      updatedMatches[index] = filtered;
      setMatchedLocations(updatedMatches);
    };

    const handleLocationSelect = (index, location) => {
      const displayValue = location.label;
      const saveValue = location.value;

      const updatedSearchValues = [...searchValues];
      updatedSearchValues[index] = displayValue;
      setSearchValues(updatedSearchValues);

      const updatedMatches = [...matchedLocations];
      updatedMatches[index] = [];
      setMatchedLocations(updatedMatches);

      const result = updatedSearchValues
        .map(getRawLocationValue)
        .filter(Boolean);

      onSelect(result);
    };

    const handleAddNewCity = () => {
      if (searchValues.length > 0 && !getRawLocationValue(searchValues[searchValues.length - 1])) {
        return;
      }
      setSearchValues([...searchValues, '']);
      setMatchedLocations([...matchedLocations, []]);
    };

    const handleRemove = index => {
      const updatedSearchValues = [...searchValues];
      updatedSearchValues.splice(index, 1);
      setSearchValues(updatedSearchValues);

      const updatedMatched = [...matchedLocations];
      updatedMatched.splice(index, 1);
      setMatchedLocations(updatedMatched);

      const result = updatedSearchValues
        .map(getRawLocationValue)
        .filter(Boolean);

      onSelect(result);
    };

    const handleBlur = () => {
      const cleanedValues = searchValues.filter(value => getRawLocationValue(value));
      const nextValues = cleanedValues.length ? cleanedValues : [''];
      setSearchValues(nextValues);
      setMatchedLocations(nextValues.map(() => []));
      onSelect(cleanedValues.map(getRawLocationValue).filter(Boolean));
    };

    return (
      <div className="location-selection-container">
        {searchValues.map((value, index) => (
          <div key={index} style={{ position: 'relative', marginBottom: '1rem' }} className="location-input-wrapper">
            <input
              type="text"
              placeholder="Enter City or State"
              value={value}
              onChange={e => handleLocationSearch(index, e)}
              onBlur={handleBlur}
              className="location-search-input"
            />
            <FaTimes
              onClick={() => handleRemove(index)}
              style={{
                position: 'absolute',
                right: '8px',
                top: '50%',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                color: '#999',
              }}
            />
            {matchedLocations[index]?.length > 0 && (
              <div
                className="location-dropdown"
                onMouseDown={event => event.stopPropagation()}
                onClick={event => event.stopPropagation()}
              >
                {matchedLocations[index].map((loc, i) => (
                  <div
                    key={i}
                    onMouseDown={event => {
                      event.preventDefault();
                      event.stopPropagation();
                      handleLocationSelect(index, loc);
                    }}
                    onClick={event => {
                      event.preventDefault();
                      event.stopPropagation();
                    }}
                    className="location-dropdown-item"
                  >
                    {loc.label}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}

        <div style={{ textAlign: 'center' }}>
          <button type="button" className="add-city-btn" onClick={handleAddNewCity}>
            + Add
          </button>
        </div>
      </div>
    );
  }

  function FilterItem({ options, selectedValues, onSelect, filterName }) {
    const handleChange = e => {
      onSelect(filterName, e.target.value);
    };
    console.log(selectedValues, 'selectedValues');
    return (
      <div className="filter-group">
        <select
          style={{ width: '100%', marginTop: '5px' }}
          name={filterName}
          value={selectedValues}
          onChange={handleChange}
          className="filter-select-input"
        >
          <option value="">Select Salary Range</option>
          {(options || []).map((option, index) => (
            <option key={index} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
    );
  }

  // Password strength checker
  const checkPasswordStrength = password => {
    let strength = 0;

    if (password.length >= 8) strength++;
    if (/[A-Z]/.test(password)) strength++;
    if (/[a-z]/.test(password)) strength++;
    if (/\W/.test(password)) strength++; // Special character

    if (strength <= 2) return 'Weak';
    if (strength === 3) return 'Fair';
    if (strength === 4) return 'Strong';
  };
  const getStrengthColor = strength => {
    switch (strength) {
      case 'Weak':
        return '#dc3545'; // red
      case 'Fair':
        return '#ffc107'; // yellow/orange
      case 'Strong':
        return '#28a745'; // green
      default:
        return '#6c757d'; // gray
    }
  };

  const getStrengthWidth = strength => {
    switch (strength) {
      case 'Weak':
        return '33%';
      case 'Fair':
        return '66%';
      case 'Strong':
        return '100%';
      default:
        return '0%';
    }
  };

  const handleFile = file => {
    const allowedTypes = [
      'application/pdf', // PDF
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
      'text/plain', // .txt
    ];
    const maxSizeInBytes = 15 * 1024 * 1024; // 5MB

    // Type validation
    if (!allowedTypes.includes(file.type)) {
      setCustomError('Invalid file type. Please upload a PDF or Word document.');
      setIsAlertOpen(true);
      return;
    }

    // Size validation
    if (file.size > maxSizeInBytes) {
      setCustomError('Maximum file size allowed is 15 MB');
      setIsAlertOpen(true);
      return;
    }

    // If valid
    setSignUpForm(prev => ({
      ...prev,
      resumeFile: file,
    }));
  };
  const [dragOver, setDragOver] = useState(false);

  const handleDrop = e => {
    e.preventDefault();
    setDragOver(false);
    const file = e.dataTransfer.files[0];
    if (file) {
      handleFile(file);
    }
  };

  const signupForm3 = () => {
    return (
      <>
        <div class="signup-wrapper">
          <div class="signup-card">
            <div class="signup-left">
              <img src={SignupPage3} alt="Sign Up Visual" />
              <div class="info-cards">
                <div class="info-card">
                  <span class="info-card-value">2x</span>
                  <br />
                  <span class="info-card-label">Job Matches</span>
                </div>
                <div class="info-card">
                  <span class="info-card-value"> 50%</span>
                  <br />
                  <span class="info-card-label">Time Saving in Job Searches</span>
                </div>
                <div class="info-card">
                  <span class="info-card-value"> 95%</span>
                  <br />
                  <span class="info-card-label">Score on mostly all ATS</span>
                </div>
                <div class="info-card">
                  <span class="info-card-value"> 50%</span>
                  <br />
                  <span class="info-card-label">More Interview Invites</span>
                </div>
              </div>
            </div>
            <div class="signup-right-form-2">
              <h2 onClick={() => navigate('/')} class="welcome-heading">
                <img src={`${process.env.PUBLIC_URL}/assets/images/logo/SeekJobsLog1.png`} alt="SeekJobs" class="inline-logo" />
              </h2>
              <h2 class="welcome-heading2"> Almost there! Upload your resume and land that dream job!</h2>
              <div className="progress-stepper">
                <div className="step completed">1</div>
                <div className="step-line"></div>
                <div className="step completed">2</div>
              </div>
              <div class="signup-form">
                <div className="form-group-login">
                  <div
                    className="resume-upload-container"
                    // onClick={() => document.getElementById("resume-upload").click()}
                    onDragOver={e => {
                      e.preventDefault();
                      setDragOver(true);
                    }}
                    onDragLeave={() => setDragOver(false)}
                    onDrop={handleDrop}
                    style={{
                      border: dragOver ? '2px dashed #4a90e2' : '2px dashed #ccc',
                      padding: '30px',
                      borderRadius: '8px',
                      textAlign: 'center',
                      cursor: 'pointer',
                      backgroundColor: dragOver ? '#f0f8ff' : '#fff',
                    }}
                  >
                    <label className="form-label mb-2">Upload Your Resume</label>
                    <label htmlFor="resume-upload" className="resume-dropzone">
                      <div className="resume-icon">
                        <img src={filedown} alt="Upload Icon" />
                      </div>
                      {!signupForm?.resumeFile && (
                        <div className="resume-text">
                          <strong>Drag & Drop</strong> <br />
                          or <br />
                          <span className="upload-link">Upload your file</span>
                          <div className="file-types">
                            Accepted file types: .docx, .pdf, .txt
                            <br />
                            Maximum file size: 15 MB
                          </div>
                        </div>
                      )}

                      <input
                        type="file"
                        id="resume-upload"
                        name="resume"
                        accept=".pdf,.doc,.docx"
                        style={{ display: 'none' }}
                        onChange={e => {
                          const file = e.target.files[0];
                          if (file) {
                            handleFile(file);
                          }
                        }}
                      />

                      {/* Error message */}
                      {error && (!signupForm?.resumeFile || signupForm?.resumeFile === '') && (
                        <div style={{ fontSize: '15px', display: 'block' }} className="text-danger text-start">
                          Field is required
                        </div>
                      )}

                      {error && (!signupForm.resumeFile || !allowedTypes.includes(signupForm.resumeFile.type)) && (
                        <div style={{ fontSize: '15px', display: 'block' }} className="text-danger text-start">
                          Unsupported media type or Invalid file type
                        </div>
                      )}

                      {/* ✅ File Uploaded Message */}
                      {signupForm?.resumeFile && (
                        <div className="text-success text-center mt-2" style={{ fontSize: '14px' }}>
                          <strong>{signupForm.resumeFile.name}</strong> uploaded successfully
                        </div>
                      )}
                    </label>

                    <p className="resume-note">
                      The privacy of your data is the top priority at SeekJobs. For more details on how SeekJobs keeps your personal data
                      private,{' '}
                      <a
                        style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}
                        onClick={() => {
                          window.open('/privacy-policy', '_blank');
                        }}
                      >
                        <span>please see our</span>
                        <i className="fa-solid fa-shield-halved font-12" style={{ margin: '0 6px' }}></i>
                        <span>Privacy Policy.</span>
                      </a>
                    </p>
                  </div>
                </div>
                {/* {(CustomError !== null ||
                  CustomError !== undefined ||
                  CustomError !== "") && (
                    <div className="text-danger text-start"> {CustomError}</div>
                  )} */}
                <div style={{ display: 'flex', gap: '10px', marginTop: '2px' }}>
                  <button
                    onClick={() => {
                      setOpenFormID(2);
                      setError(false);
                    }}
                    class="primary-btn main-second"
                    style={{ cursor: 'pointer' }}
                  >
                    Back
                  </button>
                  <button onClick={() => handleRegister()} class="primary-btn" style={{ cursor: 'pointer' }}>
                    Register
                  </button>
                </div>
              </div>
            </div>
          </div>
          {customLoader && <SignUpLoader />}
          <SuccessModel
            isOpen={finalLoginsuccessPopUp}
            title="Success"
            message={finalLoginSuccessMessage}
            buttonText="OK"
            onClose={() => {
              // handleSuccessLogin()
              setLoginItem(LoginData);
              navigate('/');
              setFinalLoginsuccessPopUp(false);
            }}
          />
          <ErrorModel isOpen={isOpenErrorModel} title="Alert!" message={message} buttonText="OK" onClose={() => setOpenErrorModel(false)} />
        </div>
      </>
    );
  };
  const signupForm2 = () => {
    return (
      <>
        <div class="signup-wrapper">
          <div class="signup-card">
            <div class="signup-left">
              <img src={SignupPage2} alt="Sign Up Visual" />
              <div class="info-cards">
                <div class="info-card">
                  <span class="info-card-value">2x</span>
                  <br />
                  <span class="info-card-label">Job Matches</span>
                </div>
                <div class="info-card">
                  <span class="info-card-value"> 50%</span>
                  <br />
                  <span class="info-card-label">Time Saving in Job Searches</span>
                </div>
                <div class="info-card">
                  <span class="info-card-value"> 95%</span>
                  <br />
                  <span class="info-card-label">Score on mostly all ATS</span>
                </div>
                <div class="info-card">
                  <span class="info-card-value"> 50%</span>
                  <br />
                  <span class="info-card-label">More Interview Invites</span>
                </div>
              </div>
            </div>
            <div class="signup-right-form-2">
              <h2 onClick={() => navigate('/')} class="welcome-heading">
                <img src={`${process.env.PUBLIC_URL}/assets/images/logo/SeekJobsLog1.png`} alt="SeekJobs" class="inline-logo" />
              </h2>
              <h2 class="welcome-heading2">
                {' '}
                <span class="highlight-text">Welcome, {signupForm?.fullName}!</span> Let’s find the perfect job for you!
              </h2>
              <div className="progress-stepper">
                <div className="step completed">1</div>
                <div className="step-line"></div>
                <div className="step upcoming">2</div>
              </div>
              <div class="signup-form">
                <div className="form-group-login">
                  <label className="login-label" htmlFor="email">
                    Preferred Employment Type
                    <span className="text-danger text-start">*</span>
                  </label>

                  <div className="job-type-options">
                    {JobType.map(option => (
                      <label key={option.value} className="remember-me job-type-option">
                        <input
                          type="checkbox"
                          checked={signupForm?.jobType?.includes(option.value)}
                          onChange={() => {
                            setSignUpForm(prev => {
                              const alreadySelected = prev?.jobType?.includes(option.value) || false;
                              return {
                                ...prev,
                                jobType: alreadySelected
                                  ? prev?.jobType.filter(val => val !== option?.value) // remove
                                  : [...prev?.jobType, option.value], // add
                              };
                            });
                          }}
                        />
                        {option.label}
                      </label>
                    ))}
                  </div>

                  {error && signupForm?.jobType.length === 0 ? (
                    <div style={{ fontSize: '15px' }} className="text-danger text-start">
                      Field is required
                    </div>
                  ) : (
                    ''
                  )}
                </div>
                <div className="form-group-login">
                  <label className="login-label" htmlFor="password">
                    What job titles are you interested in?
                    <span className="text-danger text-start">*</span>
                  </label>
                  <JobTitleFilter filters={filters} selectedValues={tempFilters.jobTitles} onSelect={handleTempFilterChange} />
                  {error && signupForm?.interestedIn.length === 0 ? (
                    <div className="text-danger text-start" style={{ fontSize: '15px' }}>
                      Field is required
                    </div>
                  ) : (
                    ''
                  )}
                </div>
                <div className="form-group-login">
                  <label className="login-label" htmlFor="email">
                    Job Location Preference
                  </label>
                  <div className="job-type-options">
                    {RelocationPreferences.map(option => (
                      <label key={option.value} className="remember-me job-type-option mb-2">
                        <input
                          type="checkbox"
                          checked={signupForm?.relocationPreferences === option.value}
                          onChange={() => {
                            setSignUpForm(prev => ({
                              ...prev,
                              relocationPreferences: prev.relocationPreferences === option.value ? null : option.value,
                            }));
                          }}
                        />{' '}
                        {option.label}
                      </label>
                    ))}
                  </div>
                  {signupForm?.relocationPreferences === 'Yes, But Within' && (
                    <>
                      <FilterLocationItem
                        filters={filters}
                        selectedValues={signupForm?.city || []}
                        onSelect={value => {
                          setSignUpForm(prev => ({
                            ...prev,
                            city: value, // ✅ setting to signupForm.city
                          }));
                        }}
                      />

                      {error && signupForm?.city?.length === 0 && (
                        <div style={{ fontSize: '15px' }} className="text-danger text-start">
                          Field is required
                        </div>
                      )}
                    </>
                  )}
                </div>
                {/* <div className="form-group-login">
                  <label className="login-label" htmlFor="salary">
                    Expected Salary Range
                  </label>
                  <FilterItem
                    title="Compensation"
                    options={filters.salary_ranges || []}
                    selectedValues={tempFilters.salaryRanges} // This must be a string, not an array
                    onSelect={handleTempFilterChange}
                    filterName="salaryRanges"
                  />
                </div> */}

                {(CustomError !== null || CustomError !== undefined || CustomError !== '') && (
                  <div className="text-danger text-start"> {CustomError}</div>
                )}
                <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
                  <button
                    onClick={() => {
                      setError(false);
                      navigate('/login');
                    }}
                    class="primary-btn main-second"
                    style={{ cursor: 'pointer' }}
                  >
                    Back
                  </button>
                  <button onClick={handleNextClicked} class="primary-btn" style={{ cursor: 'pointer' }}>
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };
  const signUpForm1 = () => {
    return (
      <>
        <div class="signup-wrapper">
          <div class="signup-card">
            <div class="signup-left">
              <img src={loginBackgroundImage} alt="Sign Up Visual" />
              <div class="info-cards">
                <div class="info-card">
                  <span class="info-card-value">2x</span>
                  <br />
                  <span class="info-card-label">Job Matches</span>
                </div>
                <div class="info-card">
                  <span class="info-card-value"> 50%</span>
                  <br />
                  <span class="info-card-label">Time Saving in Job Searches</span>
                </div>
                <div class="info-card">
                  <span class="info-card-value"> 95%</span>
                  <br />
                  <span class="info-card-label">Score on mostly all ATS</span>
                </div>
                <div class="info-card">
                  <span class="info-card-value"> 50%</span>
                  <br />
                  <span class="info-card-label">More Interview Invites</span>
                </div>
              </div>
            </div>
            <div class="signup-right">
              <h2 onClick={() => navigate('/')} class="welcome-heading">
                Welcome to
                <img src={`${process.env.PUBLIC_URL}/assets/images/logo/SeekJobsLog1.png`} alt="SeekJobs" class="inline-logo" />
              </h2>
              <h3>
                Sign up for a <span class="highlight-text">better career!</span>
              </h3>

              <div style={{ marginTop: '10px' }}>
                <GoogleLoginButton text={'Sign up with Google'} />
              </div>
              <div class="divider" style={{ margin: '10px 0' }}>
                Or
              </div>

              <form
                class="signup-form"
                onSubmit={e => {
                  e.preventDefault();
                  handleLogin();
                }}
              >
                <div class="form-group-login">
                  <label className="login-label" for="fullname">
                    Full Name
                    <span className="text-danger text-start">*</span>
                  </label>
                  <input
                    type="text"
                    id="fullname"
                    value={signupForm?.fullName}
                    maxLength={30}
                    onChange={e => {
                      let input = e.target.value;
                      if (input.startsWith(' ')) {
                        input = input.trimStart();
                      }
                      // Allow only letters, spaces, and basic punctuation (optional)
                      if (!/\d/.test(input)) {
                        setSignUpForm(prev => ({ ...prev, fullName: input }));
                      }
                    }}
                    name="fullname"
                    placeholder="Enter your full name"
                  />
                  {error && (signupForm?.fullName === null || signupForm?.fullName === undefined || signupForm?.fullName === '') ? (
                    <div className="text-danger text-start">Field is required</div>
                  ) : (
                    ''
                  )}
                </div>
                <div class="form-group-login">
                  <label className="login-label" for="email">
                    Email Address
                    <span className="text-danger text-start">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    maxLength={50}
                    placeholder="Enter your email"
                    value={signupForm?.emailID}
                    onChange={e => {
                      const input = e.target.value.replace(/\s/g, ''); // remove all spaces
                      setSignUpForm(prev => ({
                        ...prev,
                        emailID: input,
                      }));
                    }}
                  />

                  {error && (signupForm?.emailID === null || signupForm?.emailID === undefined || signupForm?.emailID === '') ? (
                    <div className="text-danger text-start">Field is required</div>
                  ) : signupForm.emailID && !isValidEmail(signupForm.emailID) ? (
                    <div className="text-danger text-start">Please enter a valid email</div>
                  ) : error && signupForm.emailID && isDisposableEmail(signupForm.emailID) ? (
                    <div className="text-danger text-start">Disposable emails are not allowed</div>
                  ) : (
                    ''
                  )}
                </div>
                <div className="form-group-login">
                  <label className="login-label" htmlFor="password">
                    Password
                    <span className="text-danger text-start">*</span>
                  </label>
                  <div className="password-wrapper">
                    <input
                      type={passwordVisible ? 'text' : 'password'}
                      id="password"
                      name="password"
                      maxLength={30}
                      placeholder="Enter your password"
                      className="password-input"
                      value={signupForm?.password}
                      onChange={e => {
                        let input = e.target.value;
                        if (input.startsWith(' ')) {
                          input = input.trimStart();
                        }
                        setSignUpForm(prev => ({
                          ...prev,
                          password: input,
                        }));
                        setPasswordStrength(checkPasswordStrength(input));
                      }}
                    />

                    <span className="toggle-password" onClick={() => setPasswordVisible(!passwordVisible)}>
                      {!passwordVisible ? <i className="fas fa-eye-slash"></i> : <i className="fas fa-eye"></i>}
                    </span>
                  </div>
                  {signupForm?.password && (
                    <div className="text-start" style={{ marginTop: '5px' }}>
                      <div style={{ fontWeight: 'bold' }}>Password Strength: {passwordStrength}</div>
                      <div
                        style={{
                          height: '8px',
                          width: '100%',
                          backgroundColor: '#e0e0e0',
                          borderRadius: '4px',
                          marginTop: '5px',
                        }}
                      >
                        <div
                          style={{
                            height: '100%',
                            width: getStrengthWidth(passwordStrength),
                            backgroundColor: getStrengthColor(passwordStrength),
                            borderRadius: '4px',
                            transition: 'width 0.3s ease',
                          }}
                        />
                      </div>
                      {!error && (
                        <ul className="text-danger mt-2 mb-0 ps-3" style={{ fontSize: '12px' }}>
                          {signupForm.password.length < 8 && <li>Password must be at least 8 characters long.</li>}
                          {!/[A-Z]/.test(signupForm.password) && <li>Password must contain at least one uppercase letter.</li>}
                          {!/[a-z]/.test(signupForm.password) && <li>Password must contain at least one lowercase letter.</li>}
                          {!/\W/.test(signupForm.password) && <li>Password must contain at least one special character.</li>}
                        </ul>
                      )}
                    </div>
                  )}
                  {error && (
                    <>
                      {/* Empty password */}
                      {signupForm?.password === null || signupForm?.password === undefined || signupForm?.password === '' ? (
                        <div className="text-danger text-start">Field is required</div>
                      ) : (
                        <ul className="text-danger mt-2 mb-0 ps-3" style={{ fontSize: '12px' }}>
                          {/* Password length */}
                          {signupForm.password.length < 8 && <li>Password must be at least 8 characters long.</li>}

                          {/* Missing uppercase letter */}
                          {!/[A-Z]/.test(signupForm.password) && <li>Password must contain at least one uppercase letter.</li>}

                          {/* Missing lowercase letter */}
                          {!/[a-z]/.test(signupForm.password) && <li>Password must contain at least one lowercase letter.</li>}

                          {/* Missing special character */}
                          {!/\W/.test(signupForm.password) && <li>Password must contain at least one special character.</li>}
                        </ul>
                      )}
                    </>
                  )}
                </div>
                <div class="form-group-login">
                  <label className="login-label" for="retype">
                    Retype Password
                    <span className="text-danger text-start">*</span>
                  </label>
                  <div className="password-wrapper">
                    <input
                      type={retypePasswordVisible ? 'text' : 'password'}
                      id="retype_password"
                      name="retype_password"
                      maxLength={30}
                      placeholder="Enter your password"
                      className="password-input"
                      value={signupForm?.confirmPassword}
                      onKeyDown={e => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          handleLogin();
                        }
                      }}
                      onChange={e => {
                        let input = e.target.value;
                        if (input.startsWith(' ')) {
                          input = input.trimStart();
                        }
                        setSignUpForm(prev => ({
                          ...prev,
                          confirmPassword: input,
                        }));
                      }}
                    />
                    <span className="toggle-password" onClick={() => setRetypePasswordVisible(!retypePasswordVisible)}>
                      {!retypePasswordVisible ? <i className="fas fa-eye-slash"></i> : <i className="fas fa-eye"></i>}
                    </span>
                  </div>
                  {error &&
                  (signupForm?.confirmPassword === null ||
                    signupForm?.confirmPassword === undefined ||
                    signupForm?.confirmPassword === '') ? (
                    <div className="text-danger text-start">Field is required</div>
                  ) : error &&
                    signupForm?.confirmPassword !== null &&
                    signupForm?.confirmPassword !== undefined &&
                    signupForm?.confirmPassword !== '' &&
                    signupForm?.confirmPassword !== signupForm?.password ? (
                    <div className="text-danger text-start">Passwords do not match</div>
                  ) : (
                    ''
                  )}
                </div>
                {/* {(CustomError !== null ||
                  CustomError !== undefined ||
                  CustomError !== "") && (
                    <div className="text-danger text-start"> {CustomError}</div>
                  )} */}

                <button type="submit" class="primary-btn" style={{ cursor: 'pointer', marginTop: '2px' }}>
                  Join Now
                </button>
                <p
                  style={{
                    fontSize: '12px',
                    color: '#6c757d',
                    marginTop: '10px',
                    textAlign: 'center',
                  }}
                >
                  By continuing, you agree to SeekJobs’&nbsp;
                  <a href="/terms-of-service" target="_blank" rel="noopener noreferrer" style={{ color: '#007bff' }}>
                    Terms of Service
                  </a>
                  &nbsp;and the&nbsp;
                  <a href="/privacy-policy" target="_blank" rel="noopener noreferrer" style={{ color: '#007bff' }}>
                    Privacy Policy
                  </a>
                </p>
                <button type="button" onClick={() => navigate('/login')} class="primary-btn main-second" style={{ cursor: 'pointer' }}>
                  Already a member? Log in
                </button>
              </form>
            </div>
          </div>
          <SuccessModel
            isOpen={initialLoginsuccessPopUp}
            title="Success"
            message={initialLoginSuccessMessage}
            buttonText="OK"
            onClose={() => {
              navigate('/');
            }}
          />
        </div>
      </>
    );
  };
  return (
    <>
      {OpenFormID === 1 ? signUpForm1() : OpenFormID === 2 ? signupForm2() : OpenFormID === 3 ? signupForm3() : <h3>Signup</h3>}
      <AlertModal isOpen={isAlertOpen} title="Alert!" message={CustomError} buttonText="Got it" onClose={() => setIsAlertOpen(false)} />
    </>
  );
};

export default Login;
